<ol class="breadcrumb">
  <li><a routerLink="/efs" (click)="updateHelp()">Home</a></li>

  <ng-container *ngIf="showCustomLabel; else elseTemplate">
    <li *ngFor="let breadcrumb of breadcrumbs | slice:0:1">
      <a (click)="fromBreadcrumb(breadcrumb.label)" [routerLink]="[breadcrumb.url]"
        [queryParams]="breadcrumb.params">{{ breadcrumb.label }}</a>
    </li>
    <li>
      <a>{{ customBreadcrumbLabel }}</a>
    </li>
  </ng-container>
  <ng-template #elseTemplate>
    <li *ngFor="let breadcrumb of breadcrumbs">
      <a (click)="fromBreadcrumb(breadcrumb.label)" [routerLink]="[breadcrumb.url]"
        [queryParams]="breadcrumb.params">{{ breadcrumb.label }}</a>
    </li>
  </ng-template>

  <!-- <li class="active">{{ activeBreadcrumb }}</li> -->
</ol>